module.exports = __webpack_public_path__ + "static/media/hackerrank_logo.7b6f6587.png";